<template>
  <div class="step-container scrollPosition haus-step-7a">
    <div class="step-header">
      <h2 class="step-title">Zusatzflächen</h2>
      <p class="step-text">Befinden sich im Haus zusätzliche Flächen?</p>
    </div>
    <div class="step-body">
      <div class="box-container">
        <SelectBox
          class="box-item small-icon-w-50"
          text="Keller / Lager / Nebengebäude"
          v-model="fields.flagKeller.value"
          :iconDefault="require('@/assets/icons/Svgs/Keller_Nebengebaeude.svg')"
          :iconHover="require('@/assets/icons/Svgs/Keller_Nebengebaeude_white.svg')"
        />
      </div>
    </div>
    <div class="step-footer">
      <div class="row align-items-center">
        <div class="col-md-4 col-6">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
        <div class="col-md-4 col-6 next-container">
          <button
            class="next-btn"
            @click="goNext()"
          >
            Weiter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SelectBox from "@/components/shared/SelectBox.vue";
import {
  getFromStorage,
  saveToStorage,
  isSet,
} from "@/utils.js";
export default {
  name: "haus-step-8a",
  components: {
    SelectBox,
  },
  data() {
    return {
      fields: {
        flagKeller: { value: "false" },
        hausKellerM2: { value: null },
      },
    };
  },
  methods: {
    isSet: isSet,
    goBack() {
      saveToStorage(this.fields);
        this.$router.push("/haus-step-7");
    },
    goNext() {
      if (!isSet(this.fields.flagKeller.value)) {
        this.fields.hausKellerM2.value = null;
      }
      saveToStorage(this.fields);
      if (
        isSet(this.fields.flagKeller.value)
      ) {
        this.$router.push("/haus-step-8b");
      } else {
        this.$router.push("/haus-step-9");
      }
    },
  },
  mounted() {
    this.$emit("setStep", "haus", 9);
    getFromStorage(this.fields);
  },
};
</script>
